import { useEffect, useState } from 'react';

import { useValuePropPreferencesQuery } from '../../../../features/preferences/useValuePropPreferencesQuery';
import { useUserQuery } from '../../../../features/user/useUserQuery';
import { CountryService, WORLDWIDE_COUNTRY_ID } from '../../../../services/country/country';

import type { SamSettings } from './Onboarding';

const initialSettings: SamSettings = { painPoint: '', valueProposition: '', metrics: [], countries: [] };
export const useSamSettings = () => {
  const { data: user } = useUserQuery();

  const { data: vpAndPp } = useValuePropPreferencesQuery();

  useEffect(() => {
    if (vpAndPp) {
      setSettings((prev) => {
        if (prev.painPoint && prev.valueProposition) {
          return prev;
        }

        return {
          ...prev,
          painPoint: vpAndPp.default.painPoint,
          valueProposition: vpAndPp.default.valueProposition,
        };
      });
    }
  }, [vpAndPp]);

  const [settings, setSettings] = useState<SamSettings>(() => {
    if (!user) {
      return initialSettings;
    }

    const painPoint = vpAndPp?.default.painPoint ?? '';
    const valueProposition = vpAndPp?.default.valueProposition ?? '';
    const settings = { ...initialSettings, painPoint, valueProposition };

    if (CountryService.isWorldwideIncluded(user.availableCountries)) {
      return { ...settings, countries: [WORLDWIDE_COUNTRY_ID] };
    }

    return settings;
  });

  return [settings, setSettings] as const;
};
